export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "J'avais peur du piège des « hallucinations de l'IA ». Je ne voulais pas qu'un tribunal rejette mes conclusions. Après 3 jours avec les prompts SIGMA SMART™, j'ai rédigé des conclusions en défense complexes en 15 minutes. Maintenant, je finis mon travail à l'heure et je dîne en famille chaque soir.",
    name: 'Robert J. M.',
    location: 'Paris, France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/c671b38a-19e1-4b5e-ad8a-7136d452eff8.jpg',
  },
  {
    quote:
      "Je me noyais sous les dossiers d'instruction, frustrée que la paperasse m'éloigne de mon vrai métier d'avocate. Ce système fonctionne vraiment. La logique du pack « Intelligence Contractuelle » est inégalée. Mes projets d'actes sont désormais la référence dans mon cabinet.",
    name: 'Sarah L.',
    location: 'Bruxelles, Belgique',
    flag: '🇧🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/90687afb-6951-4cd2-8972-de069b8659d8.jpg',
  },
  {
    quote:
      "Je craignais que l'IA ne sonne trop « robotique » pour une mise en demeure à enjeux élevés. SIGMA SMART™ m'a prouvé le contraire. Les prompts sont vérifiés, professionnels et persuasifs. Je me suis senti en confiance dès le PREMIER JOUR.",
    name: 'David P.',
    location: 'Montréal, Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e0f7d171-95bf-4fc6-880b-cdc0c670c708.jpg',
  },
];
